import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["joinButton"];
  connect() {
    this.joinButtonTarget.style.pointerEvents = "none";
    document.addEventListener("autocomplete.change", this.change.bind(this));
  }

  change() {
    this.joinButtonTarget.style.pointerEvents = "auto";
  }
}
